<template>
    <div class='shop-local-container'>
        <Toast :alert_queue='alert_queue'/>    
        <div class='shop-local'>
            <div class='shop-local-heading'>Shop local</div>
            <div v-if='local_store.id == null' @click='openStoreLookup'>
                <div class='shop-local-text see-whats-in-stock-text'>Click to shop what's in stock at your local itim store <span class='today-text'>TODAY</span></div>
            </div>
            <div v-if='local_store.id != null'>
                <div class='shop-local-text'>You are shopping to collect from your local store: <span class='store-name-text'>{{local_store.name}}</span></div>
            </div>
            <div class='shop-local-button-container' v-if='local_store.id == null'>
                <div class='shop-local-button collect' @click='openStoreLookup'>
                    <div class='shop-local-button-text'>Collect</div>
                    <div class='shop-local-button-sub-text'>Ready in 4 hours</div>
                </div>
                <div class='shop-local-button delivery'>
                    <div class='shop-local-button-text'>Delivery</div>
                    <div class='shop-local-button-sub-text'>Free local delivery</div>
                </div>
            </div>
            <div class='shop-local-button-container' v-if='local_store.id != null'>
                <div class='shop-local-button collect local-store-button-text' @click='openStoreLookup'>
                    <div class='shop-local-button-text'>Change Store</div>
                </div>
                <div class='shop-local-button delivery local-store-button-text'>
                    <div class='shop-local-button-text' @click='removeLocalStore'>Shop Full Website</div>
                </div>
            </div>
        </div>

         <Modal modal_id='store_lookup_modal' title='Select Local Store' size='xxl'>
            <LocalStoreLookup :reset_postcode='postcode' :errors='errors' :selected_local_store='local_store' @postcodeListener='selectedPostcode' />
            <StoreLookup :postcode='postcode' :postcode_watcher='postcode_watcher' :selected_local_store='local_store' @selectedStoreListener='selectedStore' @errorListener='getErrors' />
         </Modal>
    </div>
</template>

<script>
import Modal from "@/ecom/components/modals/Modal.vue";
import StoreLookup from "@/ecom/components/store_lookup/StoreLookup.vue";
import {checkAuth, openModal, closeModal} from "@/global/modules/functions.js";
import Toast from '@/ecom/components/popups/Toast.vue';
import LocalStoreLookup from '@/ecom/components/store_lookup/LocalStoreLookup.vue';

export default {
    components: {Modal, StoreLookup, Toast, LocalStoreLookup},
    data(){
        return{
            local_store: {id: null},
            alert_queue: [],
            postcode: '',
            errors: [],
            postcode_watcher: null
        }
    },
    methods:{
        openStoreLookup(){
            openModal('store_lookup_modal');
        },
        async getLocalStore(){
            let response = await fetch(`/api/store-locator/local-store`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            if (response.status === 200){

                this.local_store = results;
            }
        },
        async removeLocalStore(){
            let response = await fetch(`/api/store-locator/remove-local-store`, {
                method: 'POST',
                credentials: 'include',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}), 
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.local_store = {id: null};
            }
        },
        async selectedStore(selected_store){
            let response = await fetch(`/api/store-locator/set-local-store`, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    selected_store: selected_store
                }),
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                closeModal('store_lookup_modal');
                this.local_store = selected_store;
                this.postcode = '';
                this.errors = {};
                this.alert_queue.push({type : 'success', text: `You are now shopping at ${selected_store.name}`});
            }
        },
        selectedPostcode(postcode) {
            this.postcode = postcode;
            this.postcode_watcher = + new Date();
        },
        getErrors(errors) {
            this.errors = errors;
        }
    },
    mounted(){
        this.getLocalStore();
    }
}
</script>

<style lang="scss" scoped>
.shop-local-container{
    padding-left: 5%;
    padding-right: 5%;
}

.shop-local{
    width: 100%;
    background-color: #77777A;
    padding: 15px 50px;
    box-sizing: border-box;
    align-items: center;

    display: flex;
    justify-content: space-between;

    @media(max-width: 1400px){
        flex-direction: column;
        align-items: flex-start;
        gap: 15px;
        padding: 15px 20px;
    }
}

.shop-local-heading{
    font-size: 1.6rem;
    color: white;
    font-weight: 600;
}

.shop-local-text{
    color: white;
    font-size: 1.2rem;
}

.see-whats-in-stock-text{
    cursor: pointer;
}

.today-text{
    font-weight: 600;
}

.store-name-text{
    font-weight: 600;
}

.shop-local-button-container{
    display: flex;
    gap: 20px;

    //  @media(max-width: 768px){
    //     flex-direction: column;
    //     align-items: flex-start;
    // }

}
.shop-local-button{
    width: 200px;
    height: 50px;
    text-align: center;
    color: white;
    cursor: pointer;
    padding: 3px 0px;
    box-sizing: border-box;

    @media(max-width: 768px){
        width: 140px;
    }
}

.local-store-button-text{
    align-content: center;
}

.shop-local-button.collect{
    background-color: #B1938D;
}

.shop-local-button.delivery{
    background-color: #8E8E8E;
}

.shop-local-button-text{
    font-size: 1.2rem;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    @media(max-width: 768px){
        font-size: 0.95rem;
    }
}

.shop-local-button-sub-text{
    font-size: 0.7rem;
    font-weight: 400;
    margin-top: -3px;
}
</style>